<script lang="ts">
    import { untrack } from 'svelte';
    import type { PrimitiveLabels } from '@shared/tracking/TrackingLabels.ts';
    import type { DresonRuleResolvedEvent, Page } from '@shared/types/Tilelist.ts';
    import { injectWiring } from '@tilelist/application/wiring/TileListWiringContext.svelte.ts';
    import { appendHeurekaFragment, clean, pagedUrl } from './Utils.browser.ts';

    /**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */

    interface Props {
        rule: string;
        page?: Page;
    }

    let { rule, page }: Props = $props();

    const wiring = injectWiring(['eventsIncoming', 'eventsOutgoing', 'trackingService']);
    const onex = wiring.onex;

    /**
 *
 *
 *
 *
 *
 *
 */
    function checkpointData(rule: string, page: Page, tsLink?: PrimitiveLabels) {
        return {
            rule: rule,
            /*                                                                           */
            page: { ...page },
            tsLink,
            historic: true,
        };
    }

    /**
 *
 *
 *
 *
 *
 *
 *
 */
    function createCheckpoint(event: DresonRuleResolvedEvent) {
        const { rule, page, tsLink, historic, redirect } = event,
            cleanedPage = clean(page);

        const trackingUrl = redirect || pagedUrl(cleanedPage, window.location.pathname, window.location.search);

        /*                                                               */
        wiring.trackingService?.trackUrl(trackingUrl);

        if (historic) return;

        let url = trackingUrl;

        if (redirect && onex.isToggleActive('DA_KEEP_HEUREKA_SHEET_FRAGMENT')) {
            url = appendHeurekaFragment(url);
        }

        wiring.eventsOutgoing.pushHistoryCheckpoint({
            topic: 'ftfind.dresonRule.resolve',
            data: checkpointData(rule, page, tsLink),
            url,
        });
    }

    $effect(() => {
        const eventsOutgoing = wiring.eventsOutgoing;
        const eventsIncoming = wiring.eventsIncoming;
        if (!eventsOutgoing || !eventsIncoming) return;

        /*                                                              */
        return untrack(() => {
            /*                                                                            */
            const data = checkpointData(rule, page ?? {}, {});

            /*                                                                       */
            eventsOutgoing.seedHistoryState({
                topic: 'ftfind.dresonRule.resolve',
                data,
            });
            const unsubscribe = eventsIncoming.onPageResolved(createCheckpoint);

            return () => unsubscribe();
        });
    });
</script>
